import { createSearchParams, useNavigate } from "react-router-dom";
import { APP_URLS } from "../../const/AppConst";
import useAppState from "../../context/AppContext";
import StickButtonsBloc from "../common/StickButtonsBloc";
import { isPropositionInDraft } from '../../utils/dataUtils';
import { useState } from "react";
import LoaderModal from "../../modals/common/LoaderModal";
import DocumentRequiredElement from "../../components/common/DocumentRequiredElement";

import { isMobile } from "../../utils/utils";
import MgpLink from "../../elements/MgpLink/MgpLink";
import ImageModal from "../../modals/common/ImageModal";

export default function BienvenueBloc() {
    
    
    const navigate = useNavigate();
    const {
        state: { proposition },
        dispatch,
      } = useAppState();

    const [isLoading, setIsLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState<string>('');


    const onNextAction = async () => {
        try {
            if(proposition && isPropositionInDraft(proposition)) {
                setIsLoading(true);
            }

            setIsLoading(false);
            const nextUrl = proposition!.configuration.hasShowPriceAmount? APP_URLS.infoPersoStep0Page : APP_URLS.infoPersoStep1Page;
  
            dispatch({type: 'NEXT_INFO_STEP', path: nextUrl});
            navigate({
              pathname: nextUrl,
              search: createSearchParams({
                  id: proposition!.propositionId
              }).toString(),
            });
        } catch (error) {
            console.log(error);
        }        
       
    }

    const handleOpenInfoModal = (content: string) => {
      setImageUrl(content);
    }

    const handleCloseInfoModal = () => {
      setImageUrl('');
    }

  
  return (
    <>
      <div className="">
        <div className="grid-flex page-content">
          <div className="col-flex-4">
            <div className="">
              <p className="fw-bold fz-lg box-subTitle">Avant de démarrer le parcours, nous vous invitons à préparer les documents suivants</p>
              <div className="quick-bloc" style={isMobile() ? {} : {height: "20cap"}}>
                <div className="bg-bleu col-flex-3 ta-center pt-lg">
                  <div className="m-y-lg bloc-icon">
                    <i className="icon-personne blanc fz-lg"/>
                    <p className="fz-md blanc fw-bold p-x-lg bloc-icon mt-xs">Pour vous</p>
                  </div>
                </div>
                <div className="bg-blanc col-flex-8 p-xs">
                    {proposition?.configuration.hasIdentityUploadStep === true && 
                      <DocumentRequiredElement icon='icon-check'
                        title="Copie de votre pièce d'identité"
                        text="Carte d'identité ou passeport"
                      />
                    }
                    <DocumentRequiredElement icon='icon-check'
                      title="Attestation de droits à l'Assurance maladie"
                      text="Une attestation à jour que vous pouvez télécharger depuis le lien suivant <a href='https://www.ameli.fr' target='_blank' class='link'>https://www.ameli.fr</a>"
                      infoText={true}
                      handleClick={() => handleOpenInfoModal("Image_AM.jpg")}
                    />

                    <DocumentRequiredElement icon='icon-check'
                      title="Relevé d'identité bancaire"
                      text="Pour vous faire rembourser"
                    />
                </div>
              </div>

              <div className="quick-bloc mt-xs" style={isMobile() ? {} : {height: "25cap"}}>
                <div className="bg-bleu col-flex-3 ta-center pt-xs">
                  <div className="m-y-lg bloc-icon">
                    <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/Picto_proches_B.svg"} width="80" height="80" style={{boxShadow: "none"}} alt=""/>
                    <p className="fz-md blanc fw-bold p-x-lg bloc-icon">Pour vos ayants droit</p>
                  </div>
                </div>
                <div className="bg-blanc col-flex-8 p-xs">
                      <DocumentRequiredElement icon='icon-check'
                        title="Attestation de droits à l'Assurance maladie"
                        text="Pour votre conjoint et vos enfants de plus de 16 ans"
                      />
                      <DocumentRequiredElement icon='icon-check'
                        title="Justificatif de situation familiale"
                        text="Livret de famille, PACS ou justificatif de domicile commun et attestation sur l’honneur."
                      />
                      <DocumentRequiredElement icon='icon-check'
                        title="Autres documents"
                        text="Carte d’invalidité ou attestation MDPH pour vos enfants en situation de handicap."
                      />
                </div>
              </div>
            </div>
          </div>
          {!isMobile() && <div className=""></div>}
          <div className="col-flex-4">
            <p className="fw-bold fz-lg box-subTitle">Les 4 étapes de votre parcours en vidéo</p>
            <div style={isMobile() ? {width : "100%"} : {width : "80%"}}>
              
              <div className="" style={isMobile() ? {} : {height: "24cap"}}>
                <div className="">
                  <iframe width="100%" height="210" src="https://www.youtube.com/embed/xaVuwY7w05s" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                </div>
              </div>
              
            </div>
            <div style={isMobile() ? {width : "100%"} : {width : "80%"}}>
              <p className="text fw-medium mb-md">Estimer en toute transparence votre cotisation selon votre profil</p>
              <div className="bg-blanc p-lg">
                <div className="grid-flex">
                  <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/picto-tarif-simulateur.png"} width="70" height="70" style={{boxShadow: "none"}} alt=""/>
                  <a className="cta-bleu cta-small m-y-md" href={process.env.REACT_APP_MINI_SITE_OUTILS} target="_blank">J'estime mon tarif</a>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <StickButtonsBloc showPreviousButton={false} disabledPreviousButton={false} nextAction={onNextAction} nextButtonName={'Je démarre'} showNextButton={true}/>

      {imageUrl && <ImageModal isOpen={true} name={imageUrl} onCloseModal={handleCloseInfoModal}/>}
          
      {isLoading&&<LoaderModal hasMessage={false}/>}
     </>
  );
  }